import React, { useState, useEffect } from "react";
import { Typography, Container, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./App.css";
import "./Home.css";

// Uses .home-paper class for radius/padding/shadow — no inline overrides.
const HomePaper = (props) => (
  <Paper elevation={3} className="home-paper">
    {props.children}
  </Paper>
);

// Image sets
const imageSets = [
  { src: "/VillasImages/IMG-1389.JPG" },
  { src: "/VillasImages/IMG-1388.JPG" },
  { src: "/VillasImages/IMG-1390.JPG" },
  { src: "/images/Redjanephotoshooting-1.JPG" },
  { src: "/images/RedjaneUse2.JPG" },
  { src: "/images/Redjane photoshooting-26.jpg" },
  {
    src: "/TouristAccomondationImages/6c7d9917-2ff9-471e-b4c2-c23bdb5eddc5.jpeg",
  },
  {
    src: "/TouristAccomondationImages/78836613-6cbb-41d9-8a50-44340d044895.jpeg",
  },
  { src: "/VillaLI/imageedit_3_7187759230.jpg" },
  { src: "/VillaLI/imageedit_5_8421004487.jpg" },
  { src: "/VillaLI/imageedit_1_3199745661.jpg" },
  { src: "/VillaDiamantakis/DSC6329.jpg" },
  { src: "/VillaDiamantakis/IMG_1467.png" },
  { src: "/VillaDiamantakis/DSF2562.jpg" },
];

const Home = () => {
  const { t } = useTranslation();
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // slideshow
  const [paused, setPaused] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0); // <-- νέο state

  useEffect(() => {
    const interval = setInterval(() => {
      if (!paused) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageSets.length);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [paused]);

  const handleImageClick = () => {
    setPaused(true);
    setLightboxIndex(currentImageIndex); // Lightbox index ξεχωριστό
    setLightboxOpen(true);
  };

  return (
    <Container
      maxWidth="lg"
      style={{ paddingBottom: 32, minHeight: "100vh", overflow: "hidden" }}
    >
      <HomePaper>
        <div className="hero-section">
          {/* h2 styles (font, color, size) come from MUI theme */}
          <Typography variant="h2" align="center" sx={{ mt: { xs: 2, md: 4 } }}>
            {t("welcome")}
          </Typography>

          {/* Elegant horizontal divider under the welcome heading */}
          <div
            style={{
              width: 60,
              height: 2,
              backgroundColor: "#576a89",
              opacity: 0.4,
              margin: "20px auto 0",
            }}
          />

          <Typography
            align="center"
            sx={{ mt: 3, mb: 1, maxWidth: 720, mx: "auto" }}
          >
            {t("Manios")}
          </Typography>
          <div
            style={{
              width: 60,
              height: 2,
              backgroundColor: "#576a89",
              opacity: 0.4,
              margin: "20px auto 20px",
            }}
          />
          {/* Slideshow with fade transition */}
          <div className="slideshow-container">
            {imageSets.map((img, index) => (
              <img
                key={index}
                src={img.src}
                alt={`Luxury villa ${index + 1}`}
                className={`slideshow-image ${
                  index === currentImageIndex ? "active" : ""
                }`}
                onClick={handleImageClick}
              />
            ))}
          </div>
        </div>
        {/* Elegant horizontal divider under the welcome heading */}
        <div
          style={{
            width: 60,
            height: 2,
            backgroundColor: "#576a89",
            opacity: 0.4,
            margin: "20px auto 0",
          }}
        />

        <Typography
          align="center"
          sx={{ mt: 3, mb: 1, maxWidth: 720, mx: "auto" }}
        >
          {t("Feel free to browse through our ")}
          <Link to="/portfolio" className="portfolio-link">
            {t("Portfolio")}
          </Link>
          {t("and learn more about our work.")}
        </Typography>
      </HomePaper>

      {/* Lightbox Component */}
      <Lightbox
        open={lightboxOpen}
        close={() => {
          setLightboxOpen(false);
          setPaused(false);
        }}
        slides={imageSets}
        index={lightboxIndex} // <-- Lightbox index
        on={{
          view: ({ index }) => setLightboxIndex(index), // sync όταν αλλάζεις μέσα στο lightbox
        }}
      />
    </Container>
  );
};

export default Home;
